import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface DeleteOrganisationVariables {
  organisationId: string;
  confirmationName: string;
}

export const useDeleteOrganisation = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ organisationId, confirmationName }: DeleteOrganisationVariables) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
        data: { confirmationName },
      });
      const response = await fetch(`${APIBaseChronos}/api/org/${organisationId}`, fetchConfig);

      if (!response.ok) {
        const data = (await response.json().catch(() => ({}))) as { message?: string | string[] };
        const message = Array.isArray(data.message) ? data.message.join(', ') : data.message;
        throw new Error(message ?? 'Failed to delete organisation');
      }

      return organisationId;
    },
    onSuccess: () => {
      toast.success('Organisation deletion queued');
      void queryClient.invalidateQueries('all-orgs');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to delete organisation. Please try again.');
    },
  });
};
